// extracted by mini-css-extract-plugin
export default {"slotHeaderContainer":"slotHeader_slotHeaderContainer__mk36y","moreIcon":"slotHeader_moreIcon__vdmal"};